import { render, staticRenderFns } from "./OrdersPaymentDue.vue?vue&type=template&id=34a46850&scoped=true"
import script from "./OrdersPaymentDue.vue?vue&type=script&lang=js"
export * from "./OrdersPaymentDue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a46850",
  null
  
)

export default component.exports